
import { createClient } from '@supabase/supabase-js';
import { Database } from '@/types/supabase';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBjZm1vZWdpc3ZsanNyZWhvYWJkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzM3NzA3MDgsImV4cCI6MjA0OTM0NjcwOH0.i1mDxl5scP6lt-h9B5X0jD1aXTFWvsTuMZpG5oR_lfo";

export const supabaseExtended = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
